import { ROWS } from 'containers/admin/clients/client/tabs-components/goals-tab/goals-tab.constants';
import type { Goal } from 'containers/user/goals/use-goals';

export interface GoalCategoryGroup {
  category: string;
  goals: Goal[];
}

const groupGoalsByCategory = (goalsList: Goal[]): Record<string, Goal[]> =>
  goalsList.reduce<Record<string, Goal[]>>((acc, goal) => {
    const category = goal.category;

    if (category === 'Other') return acc;

    const hasEthnicity = goal.details?.some(
      (detail) => detail.focusArea === 'Ethnicity'
    );

    if (hasEthnicity) return acc;

    const cat = category as string;

    if (!acc[cat]) {
      acc[cat] = [];
    }
    acc[cat].push(goal);

    return acc;
  }, {});

export const getSortedGoalCategoryGroups = (
  goals: Goal[]
): GoalCategoryGroup[] => {
  const goalsByCategory = groupGoalsByCategory(goals);
  const categories = Object.keys(goalsByCategory);

  const orderMap = Object.values(ROWS).reduce<Record<string, number>>(
    (map, key, index) => {
      map[key as string] = index;

      return map;
    },
    {}
  );

  const sortedCategories = categories.toSorted(
    (a: string, b: string) => (orderMap[a] ?? 0) - (orderMap[b] ?? 0)
  );

  return sortedCategories.map((category) => ({
    category,
    goals: goalsByCategory[category],
  }));
};
